/*
 * Home Component
 * 
*/

import React from 'react';
import { Link } from 'react-router-dom';
import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';
import {Image, Panel, Col, Row} from 'react-bootstrap';
import {connect} from 'react-redux';

//APPs
import Utils from '../../utils/utils';
import UserApi from '../../api/user-api';
import appRouter from '../../utils/appRouter';
import WinnersApi from '../../api/winner-api';

// COMPONENTS
import LoginForm from './loginForm.component.jsx';
import TableWinners from '../shared/tableWinners.component.jsx';

class Home extends React.Component {
	constructor(props) {
		super(props);
	}

	componentWillMount(){
		WinnersApi.getWinners();
	}

	render() {
		return (
			<div>
				{/* ACTIVATION SECTION */}
				<div className="container-flex">
					<Panel>
						<Row>
							<Col sm={12}>
								<div className="panel-activation">
									<Col sm={12}>
										<h1 className="text-bold text-pink text-center"><FormattedMessage id="activation.title"/></h1>
									</Col>
									<div className="clearfix"></div>

										{/* <Game /> */}
										<LoginForm />
								</div>
							</Col>
						</Row>
					</Panel>					
				</div>				
				
				{/* DESCRIPTION PANEL */}
				{!UserApi.hasPlanActive(this.props.user) &&
				<div className="panel-description">
					<div className="container-secondary">
						<Panel>
							<p><FormattedHTMLMessage id="panelDescription.text"/></p>
						</Panel>					
					</div>
					<div className="container-flex">
					<Col md={12}>
						<Link to={appRouter.getLink('help')} className="btn full btn-info">
							<FormattedHTMLMessage id="panelDescription.btn.info"/>
						</Link>
					</Col>
					</div>
				</div>
				}

				{/* PURPLE PANEL */}
				{!UserApi.hasPlanActive(this.props.user) &&
				<div className="bg-purple">
					<Panel className="panel-purple text-center shadow">
						<Row>							
							<Image src={Utils.getImgPath() + "panel-add-img.png"} alt="" className="img-add"/>							
							<Col md={12}>
								<h1 className="text-bold text-white"><FormattedMessage id="panelPurple.title"/></h1>
								<h2 className="text-regular text-white"><FormattedMessage id="panelPurple.subTitle"/></h2>
							</Col>
							<Image src={Utils.getImgPath() + "baloon-add.png"} alt="" className="img-baloon-add"/>
						</Row>
					</Panel>
				</div>
				}
				
				{/* DEFAULT PANEL */}
				{!UserApi.hasPlanActive(this.props.user) &&
				<div className="container-secondary">
					<Panel>
						<h2><FormattedMessage id="panelDefault.title"/></h2>
						<p><FormattedHTMLMessage id="panelDefault.text"/></p>
					</Panel>
				</div>
				}

				{/* TOPIC PANEL */}
				<div className="bg-green shadow">
					<div className="panel-topics container-flex">
						<Panel>
							<h1 className="text-center text-bold"><FormattedMessage id="panelTopics.title"/></h1>
							<h2 className="text-regular text-center"><FormattedMessage id="panelTopics.subTitle"/></h2>

							<Col xs={12} sm={4}>
								<div className="text-center">
									<Image src={Utils.getImgPath() + "baloon1.png"} alt="" className="baloon hidden-xs"/>
								</div>
								<div className="control-description clearfix">
									<Image src={Utils.getImgPath() + "baloon1.png"} alt="" className="baloon-xs visible-xs"/>
									<p className="marker">1</p>
									<p className="description hidden-lg hidden-md hidden-sm">
										<FormattedMessage id="panelTopics.marker1.text1"/>
									</p>
									<p className="description hidden-xs">
										<FormattedHTMLMessage id="panelTopics.marker1.text2"/>
									</p>
								</div>
							</Col>

							<Col xs={12} sm={4}>
								<div className="text-center">
									<Image src={Utils.getImgPath() + "baloon2.png"} alt="" className="baloon hidden-xs"/>

									<div className="control-description clearfix">
										<Image src={Utils.getImgPath() + "baloon2.png"} alt="" className="baloon-xs visible-xs"/>

										<p className="marker">2</p>
										<p className="description hidden-lg hidden-md hidden-sm">
											<FormattedMessage id="panelTopics.marker2.text1"/>
										</p>
										<p className="description hidden-xs">
											<FormattedHTMLMessage id="panelTopics.marker2.text2"/>
										</p>
									</div>
								</div>
							</Col>

							<Col xs={12} sm={4}>
								<div className="text-center">
									<Image src={Utils.getImgPath() + "baloon3.png"} alt="" className="baloon hidden-xs"/>

									<div className="control-description clearfix">
										<Image src={Utils.getImgPath() + "baloon3.png"} alt="" className="baloon-xs visible-xs"/>
										<p className="marker">3</p>
										<p className="description hidden-lg hidden-md hidden-sm">
											<FormattedMessage id="panelTopics.marker3.text1"/>
										</p>
										<p className="description hidden-xs">
											<FormattedHTMLMessage id="panelTopics.marker3.text2"/>
										</p>
									</div>									
								</div>
							</Col>
						</Panel>
					</div>
				</div>			

				{/* TOPIC PANEL 2 */}
				<div className="container-secondary">
					<Panel className="panel-topics-description">					  
						<p><FormattedHTMLMessage id="panelPurple.text2"/></p>
					</Panel>
				</div>
				<div className="container-flex">
				<Col md={12}>
					<Link to={appRouter.getLink('regulation')} className="btn full btn-success">
						<FormattedHTMLMessage id="panelPurple.btn"/>
					</Link>
				</Col>
				</div>


				{/* WINNERS PANEL */}
				
					<div className="bg-red shadow hideOverflow">
						<div className="container-secondary">
							<Panel className="panel-ganhadores">
								<Image src={Utils.getImgPath() + "panel-ganhadores-img.png"} alt="" className="ganhadores-img hidden-sm hidden-xs"/>
								<Image src={Utils.getImgPath() + "baloon-ganhadores.png"} alt="" className="baloon-ganhadores hidden-sm hidden-xs"/>
								<h1 className="text-bold text-center text-white"><FormattedHTMLMessage id="panelWinners.title"/></h1>										
								<h2 className="text-light text-center text-white"><FormattedHTMLMessage id="panelWinners.subTitle"/></h2>								
							</Panel>
						</div>
					</div>

					<div className="container-flex">						
						<Col md={12} className="panel-ganhadores">
							<TableWinners period="MONTHLY" winner={this.props.winner["MONTHLY"]} size={5} />
							<TableWinners period="WEEKLY" winner={this.props.winner["WEEKLY"]} size={5} />
							<TableWinners period="TRIMESTRIAL" winner={this.props.winner["TRIMESTRIAL"]} size={5} />
						</Col>						
					</div>

			</div>
		)
	}
}


const mapStateToProps = function (store) {
	return {
		location: store.locationState.location,
		winner: store.winnerState,
		user: store.userState
	};
};

export default connect(mapStateToProps)(Home);


// WEBPACK FOOTER //
// ./src/components/pages/home.component.jsx